<template>
    <div class="filter-content-entry filter-extra-content" data-tab="extraContent">
        <div class="filter-content-entry-mobile-title">
            <a href="#" class="btn btn-rebrand-grey-outline btn-rebrand-xxs px-2 back">{{translate.account.onboard.back}}</a>
            <span class="filter-title">{{translate.home.extraContent}}</span>
            <a href="#" class="btn btn-rebrand-black btn-rebrand-xxs ml-auto px-2"
               @click.prevent="clearAllFilters()">{{translate.home.clearAll}}</a>
        </div>
        <div class="row mb-5 filter-content-your-selection">
            <div class="col-md-12">
                <div class="section-heading mt-0 pt-0 border-0">{{ translate.home.yourSelection }}</div>
                <div class="filter-content-your-selection-list">
                    <search-filter-flairs-scoped-component filterProp="extraContent"></search-filter-flairs-scoped-component>
                    <a href="#" class="clear-filter-link" @click.prevent="clearAllFilters()">{{ translate.home.clearAll }}</a>
                </div>
            </div>
        </div>
        <div class="row filter-content-container">
            <div class="col-md-8 col-lg-6">
                <div class="section-heading mt-0 d-none d-sm-block">{{ translate.account.privateGallery }}</div>

                <div class="radio-group-v2 full-width">
                    <input type="radio" name="privateGallery" id="inputHasPrivateGallery"
                           @click="onFilterUpdated('privateGallery')" class="form-check-input" :value="Number(!extraContentTemp.privateGallery)"
                           :checked="extraContentTemp.privateGallery === true"
                    >
                    <label for="inputHasPrivateGallery">{{ translate.home.hasAGallery }}</label>
                </div>
            </div>

            <div class="col-md-8 col-lg-6">
                <div class="section-heading mt-0 d-none d-sm-block">{{ translate.account.videos }}</div>

                <div class="radio-group-v2 full-width">
                    <input type="radio" name="videos" id="inputHasVideos"
                           @click="onFilterUpdated('videos')" class="form-check-input" :value="Number(!extraContentTemp.videos)"
                           :checked="extraContentTemp.videos === true"
                    >
                    <label for="inputHasVideos">{{ translate.home.hasAVideos }}</label>
                </div>
            </div>

            <div class="col-md-8 col-lg-6">
                <div class="section-heading mt-0 d-none d-sm-block border-0">{{ translate.home.fsk18Content }}</div>

                <div class="radio-group-v2 full-width">
                    <input type="radio" name="fskContent" id="inputHasFfkContent"
                           @click="onFilterUpdated('fskContent')" class="form-check-input" :value="Number(!extraContentTemp.privateGallery)"
                           :checked="extraContentTemp.fskContent === true"
                    >
                    <label for="inputHasFfkContent">{{ translate.home.hasFskContent }}</label>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
const data = () => {
    return {
        lodash: _,
        store: $store,
        unSubscribe: null,
    }
};

function mounted() {
    this.unSubscribe = this.store.subscribe((mutation) => {
        if (mutation.type === 'setFilterOpened'
            && mutation.payload
            && (!Object.keys(this.extraContentTemp).length)
        ) {
            this.store.commit('setExtraContentTemp', _.cloneDeep(this.extraContent));
        }
    });
}

function onFilterUpdated(variable) {
    const tmp = _.cloneDeep(this.extraContentTemp);
    tmp[variable] = !tmp[variable];

    this.store.commit('setExtraContentTemp', tmp);
}

function clearAllFilters() {
    this.store.commit('setExtraContentTemp', {});
}

export default {
    data,
    mounted,
    methods: {
        clearAllFilters,
        onFilterUpdated,
    },
    computed: {
        ...mapState([
            'extraContent',
            'extraContentTemp',
            'translate',
        ]),
    },
    beforeDestroy() {
        if (this.unSubscribe) {
            this.unSubscribe();
        }
    },
}
</script>
